import React, {Component} from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import chevron from '../../img/icons/chevron.svg'
import SVGSymbol from '../SVGSymbol'
import CircleSpinner from "../Widgets/CircleSpinner"
import filter from 'lodash/filter'
import {addToCart, addToWishlist} from '../../actions/account'
import {getItemsAddingToCart} from '../../selectors'
import tickImg from '../../img/icons/tick.svg'

class AddToBag extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            selectedSimple: null
        };
    }

    componentDidMount() {
        this._dropdownContainerRef.addEventListener("blur", this._closeDropdown);
    }

    componentWillUnmount() {
        this._dropdownContainerRef.removeEventListener("blur", this._closeDropdown);
    }

    _openDropdown = () => {
        this.setState({open: true})
        this._dropdownContainerRef.focus();
    }

    _closeDropdown = () => {
        this.setState({open: false})
    }

    _onAddToBagClick = () => {
        const {product, itemsAddingToCart, handleAddToBag} = this.props;
        const itemAddingToCart = itemsAddingToCart[product.sku];
        if(itemAddingToCart) return;

        var selectedSimple = this.state.selectedSimple;
        if(selectedSimple === null)
        {
            this._openDropdown();
            return
        }
        if(selectedSimple.quantity === 0) {
            return
        }

        handleAddToBag(product.sku, selectedSimple.sku)
    }

    _onDropdownClick = (event) => {
        var newState = !this.state.open;
        if( newState )
            this._openDropdown();
        else
            this._closeDropdown();
    }

    _onSimpleMouseDown = (event, simple) => {
        event.preventDefault();
        this.setState({
            open: false,
            selectedSimple: simple
        });
    }

    _onNotifyMe = (event, simple) => {
        event.preventDefault();
        this.setState({
            open: false,
            //selectedSimple: simple
        });
        const {product, handleAddToWishlist} = this.props;
        handleAddToWishlist(product.sku, simple.sku);
    }

    _setDropdownContainerRef = (ref) => this._dropdownContainerRef = ref;

    render() {
        const {classes, product, itemsAddingToCart} = this.props;
        const itemAddingToCart = itemsAddingToCart[product.sku];
        if(!product) return null;
        const outOfStock = product.simples && filter(product.simples, x => x.quantity > 0).length === 0;
        const {selectedSimple} = this.state;

        return <div>
            <div className={classes.blocker}></div>
            <div className={classes.dropdownContainer}>
                <button type="button" className={cn(classes.button, classes.dropdown, 'small')} onClick={this._onDropdownClick} ref={this._setDropdownContainerRef}>
                    {outOfStock && ! selectedSimple && <span className={classes.soldOut}>Out of stock</span>}
                    {!outOfStock && ! selectedSimple && <span>Pick a size...</span>}
                    {selectedSimple && <span className={cn({[classes.soldOut]: selectedSimple.quantity === 0})}>{selectedSimple.size}</span>}
                    <SVGSymbol icon={chevron} className={classes.chevron} />
                </button>
                <ul className={cn(classes.dropdownBox, {show: this.state.open})} >
                {product.simples && product.simples.map(simple => (

                    <li key={simple.sku} className={cn(classes.productSizeOption, {selected: selectedSimple && selectedSimple.sku === simple.sku})}
                        onMouseDown={e => this._onSimpleMouseDown(e, simple)}>
                        <div className={classes.theSize}>
                            <p className={cn({[classes.soldOut]: simple.quantity === 0})}>
                                {simple.size}
                                {simple.universalSize && <span className={cn(classes.universalSize, {selected: selectedSimple && selectedSimple.sku === simple.sku})}><br />{simple.universalSize}</span>}
                            </p>
                        </div>
                        <div className={classes.stockLevel}>
                            {simple.quantity === 0 &&
                                <p><button type="button" onMouseDown={e => this._onNotifyMe(e, simple)} className={cn(classes.button, classes.notifyMe)}>Notify me</button> </p>}
                            {simple.quantity === 1 &&
                                <p>1 item left</p>}
                            {simple.quantity > 1 && simple.quantity <= 3 &&
                                <p>Low in Stock</p>}
                        </div>
                    </li>
                ))}
                </ul>
            </div>
            <button className={cn(classes.button, 'small', {disabled: outOfStock || (selectedSimple && selectedSimple.quantity === 0) || itemAddingToCart})} onClick={this._onAddToBagClick}>
                <CircleSpinner show={itemAddingToCart && itemAddingToCart.state === 'adding'} className={classes.spinner} containerClassName={classes.spinnerContainer} />
                {itemAddingToCart && itemAddingToCart.state === 'added' && <SVGSymbol icon={tickImg} className={classes.icon} />}
                {itemAddingToCart && itemAddingToCart.state === 'added' ?
                    <span>Added</span> :
                    <span>Add to Bag</span> }
            </button>
        </div>
    }
}


const mapStateToProps = (state) => {
    return {
        itemsAddingToCart: getItemsAddingToCart(state)
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleAddToBag: (sku, simpleSku) => {
            dispatch(addToCart(sku, simpleSku))
        },
        handleAddToWishlist: (sku, simpleSku) => {
            dispatch(addToWishlist(sku, simpleSku))
        },
    }
}

export default injectSheet( (theme) => (
{
    spinnerContainer: {
        position: 'absolute',
        top: 3,
        left: 0
    },
    icon: {
        width: 16,
        height: 16,
        position: 'absolute',
        left: 5
    },
    spinner: {
        fill: theme.colors.white,
        width: 24,
        height: 24
    },

    button: {
        position: 'relative',
        color: theme.colors.white,
        backgroundColor: theme.colors.primary,
        display: 'block',
        width: '100%',
        appearance: 'none',
        border: '1px solid ' + theme.colors.primary,
        borderRadius: 2,
        cursor: 'pointer',
        margin: 0,
        outline: 0,
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        transition: 'background-color .25s ease-out,color .25s ease-out',
        verticalAlign: 'middle',
        minHeight: 48,
        fontSize: theme.convertFromIconicRemValue(0.75),
        lineHeight: theme.convertFromIconicRemValue(1),
        padding: '16px 20px 14px',
        ...theme.font.familyBoldStyle,
        marginBottom: theme.convertFromIconicRemValue(0.5),
        '&:hover': {
            backgroundImage: 'linear-gradient(rgba(255,255,255,.2),rgba(255,255,255,.2))'
        },
        "&.small": {
            padding: '8px 10px 7px',
            minHeight: 32,
        },
        "&.disabled": {
            borderColor: '#d2d2d2!important',
            color: '#fff!important',
            backgroundColor: '#d2d2d2!important',
            backgroundImage: 'none!important',
            cursor: 'not-allowed',
        }
    },
    dropdownContainer: {
        position: 'relative',
    },
    dropdown: {
        fontSize: theme.convertFromIconicRemValue(0.8125),
        lineHeight: theme.convertFromIconicRemValue(1),
        paddingLeft: theme.convertFromIconicRemValue(1),
        paddingRight: theme.convertFromIconicRemValue(1),
        background: theme.colors.white,
        border: `${theme.convertFromIconicRemValue(0.0625)} solid #d2d2d2`,
        color: '#232323',
        textAlign: 'left',
        textTransform: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minHeight: 40,
        padding: '16px 20px 14px',
        fontFamily: theme.font.family,
        '&:hover': {
            borderColor: '#42abc8',
        },
        "&.small": {
            padding: '6px 24px 5px 8px',
            minHeight: 32,
        }
    },
    chevron: {
        color: theme.colors.primary,
        width: 12,
        height: 12,
        position: 'absolute',
        right: 6,
        top: 'calc(50% - 6px)'
    },
    dropdownBox: {
        display: 'none',
        padding: 0,
        border: '1px solid #d2d2d2',
        borderRadius: theme.convertFromIconicRemValue(0.125),
        boxShadow: `0 0 ${theme.convertFromIconicRemValue(0.625)} 0 rgba(0,0,0,.1)`,
        fontSize: theme.convertFromIconicRemValue(0.875),
        listStyle: 'none',
        maxHeight: 'none',
        //zIndex: 89;
        background: theme.colors.white,
        zIndex: 1200,

        height: '100vh',
        left: 0,
        margin: 0,
        overflowY: 'scroll',
        position: 'fixed',
        top: 0,
        width: '100%',

        [theme.breakpoint("tablet")]: {
            height: 'auto',
            left: '50%',
            margin: '-4px 0 0 -52%',
            overflowY: 'auto',
            position: 'absolute',
            top: '100%',
            width: 250, //'auto',
            maxWidth: theme.convertFromIconicRemValue(18.75),
            minWidth: '104%',
        },
        '&.show': {
            display: 'block',
        },
        "& li:hover": {
            background: '#f0f8fb'
        },
    },
    productSizeOption: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        flexFlow: 'row wrap',
        height: theme.convertFromIconicRemValue(3.25),
        marginBottom: '0!important',
        padding: '0 8px',
        position: 'relative',
        margin: 0,
        borderBottom: '1px solid #d2d2d2',
        color: '#464646',
        cursor: 'pointer',
        lineHeight: theme.convertFromIconicRemValue(2.875),
        '& p': {
            margin: 0,
            fontSize: theme.convertFromIconicRemValue(0.875),
            lineHeight: theme.convertFromIconicRemValue(1),
            textAlign: 'left',
        },
        '&.selected': {
            background: '#fbfdfe',
            color: theme.colors.primary,
        }

    },
    theSize: {
        flex: '0 1 auto',
    },
    stockLevel: {
        '& p': {
            fontSize: theme.convertFromIconicRemValue(0.7),
        }
    },
    universalSize: {
        color: '#afafaf',
        fontSize: theme.convertFromIconicRemValue(0.75),
        "&.selected": {
            color: theme.colors.primary,
        }
    },
    soldOut: {
        color: '#ef423c'
    },
    notifyMe: {
        minHeight: 30,
        padding: `${theme.convertFromIconicRemValue(0.4375)} ${theme.convertFromIconicRemValue(0.75)} ${theme.convertFromIconicRemValue(0.375)}`,
        borderColor: theme.colors.primary,
        color: theme.colors.primary,
        backgroundColor: 'transparent',
        fontSize: theme.convertFromIconicRemValue(0.6875),
        lineHeight: theme.convertFromIconicRemValue(0.9375),
        "&:hover": {
            borderColor: theme.colors.primary,
            color: theme.colors.white,
            backgroundColor: theme.colors.primary
        }
    }

}))(connect(mapStateToProps, mapDispatchToProps)(AddToBag))





// WEBPACK FOOTER //
// ./src/components/ShopThLook/AddToBag.js